import React, { useContext } from "react"
import { Link } from "gatsby"
import BannerVisibilityContext from "../context/BannerVisibilityContext"

const TopBanner = () => {
	const { isBannerVisible, setIsBannerVisible } = useContext(BannerVisibilityContext)

	return (
		<>
			{isBannerVisible && (
				<div className="w-full flex flex-row items-center px-10 h-[48px] bg-[linear-gradient(89.94deg,#021A32_0%,#062440_53.81%,#246EA7_99.61%)]">
					<div className="flex-1 flex flex-row justify-start md:justify-center">
						<Link
							to="/ai"
							data-umami-event="click-learn-more-about-ai-features"
							className="uppercase text-sm font-medium text-current flex flex-row space-x-6 text-white hover:text-pictonblue justify-center items-center">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
								className="hidden md:inline text-white">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M19.8742 7.79347C19.957 7.82656 19.9989 7.91124 20 7.99659C20.0011 8.08421 19.9592 8.17256 19.8742 8.20653C19.8073 8.23329 19.7411 8.26127 19.6755 8.29044C19.5161 8.36132 19.3606 8.43924 19.2095 8.52381C19.186 8.53699 19.1625 8.55033 19.1392 8.56383C18.2782 9.06196 17.562 9.77817 17.0638 10.6392C17.0504 10.6625 17.037 10.6859 17.0239 10.7094C16.9393 10.8606 16.8613 11.016 16.7904 11.1755C16.7613 11.2411 16.7333 11.3073 16.7065 11.3742C16.6395 11.5419 16.3605 11.5419 16.2935 11.3742C16.2667 11.3073 16.2387 11.2411 16.2096 11.1755C16.1387 11.016 16.0607 10.8606 15.9761 10.7094C15.963 10.6859 15.9496 10.6625 15.9362 10.6392C15.438 9.77817 14.7218 9.06196 13.8608 8.56383C13.8375 8.55035 13.8141 8.53703 13.7906 8.52388C13.6394 8.43928 13.484 8.36134 13.3245 8.29044C13.2589 8.26127 13.1927 8.23329 13.1258 8.20653C12.9581 8.13946 12.9581 7.86054 13.1258 7.79347C13.1927 7.76671 13.2589 7.73873 13.3245 7.70956C13.484 7.63867 13.6394 7.56073 13.7906 7.47613C13.8141 7.46297 13.8375 7.44965 13.8608 7.43617C14.7218 6.93804 15.438 6.22183 15.9362 5.36081C15.9496 5.3375 15.963 5.31409 15.9761 5.29058C16.0607 5.13943 16.1387 4.98396 16.2096 4.82455C16.2387 4.75895 16.2667 4.69269 16.2935 4.62578C16.3271 4.54175 16.4139 4.49982 16.5006 4.5C16.5869 4.50018 16.6731 4.54211 16.7065 4.62578C16.7333 4.69269 16.7613 4.75895 16.7904 4.82455C16.8613 4.98397 16.9393 5.13945 17.0239 5.29061C17.037 5.31412 17.0504 5.33751 17.0638 5.36081C17.562 6.22183 18.2782 6.93804 19.1392 7.43617C19.1625 7.44963 19.1858 7.46292 19.2093 7.47606C19.3605 7.56069 19.516 7.63865 19.6755 7.70956C19.7411 7.73873 19.8073 7.76671 19.8742 7.79347Z"
									fill="currentColor"
								/>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M14.0086 13.4513C12.2808 12.6161 10.8839 11.2192 10.0487 9.49138C10.0243 9.44092 10.0004 9.39017 9.97695 9.33915C9.89212 9.15441 9.81364 8.96604 9.7418 8.77432C9.72298 8.72409 9.70461 8.67362 9.6867 8.62293C9.62879 8.45902 9.37121 8.45902 9.3133 8.62293C9.2954 8.67362 9.27703 8.72409 9.2582 8.77432C9.18636 8.96604 9.10789 9.1544 9.02306 9.33915C8.99963 9.39017 8.97571 9.44092 8.95132 9.49138C8.11614 11.2192 6.71917 12.6161 4.99138 13.4513C4.94083 13.4758 4.89 13.4997 4.8389 13.5232C4.65423 13.608 4.46595 13.6864 4.27432 13.7582C4.22408 13.777 4.17362 13.7954 4.12293 13.8133C4.03826 13.8432 3.99733 13.9264 4.00013 14.0078C4.00276 14.084 4.04369 14.1587 4.12293 14.1867C4.17362 14.2046 4.22409 14.223 4.27432 14.2418C4.46614 14.3137 4.6546 14.3922 4.83944 14.4771C4.89036 14.5005 4.94101 14.5243 4.99138 14.5487C6.71917 15.3839 8.11614 16.7808 8.95132 18.5086C8.97575 18.5592 8.99971 18.61 9.02317 18.6611C9.10796 18.8458 9.18639 19.0341 9.2582 19.2257C9.27703 19.2759 9.2954 19.3264 9.3133 19.3771C9.34323 19.4618 9.42649 19.5027 9.50796 19.4999C9.58412 19.4972 9.65872 19.4563 9.6867 19.3771C9.70461 19.3264 9.72298 19.2759 9.7418 19.2257C9.81368 19.0339 9.8922 18.8454 9.97708 18.6606C10.0005 18.6096 10.0243 18.559 10.0487 18.5086C10.8839 16.7808 12.2808 15.3839 14.0086 14.5487C14.0591 14.5243 14.1098 14.5004 14.1609 14.477C14.3456 14.3921 14.534 14.3136 14.7257 14.2418C14.7759 14.223 14.8264 14.2046 14.8771 14.1867C15.041 14.1288 15.041 13.8712 14.8771 13.8133C14.8264 13.7954 14.7759 13.777 14.7257 13.7582C14.534 13.6864 14.3456 13.6079 14.1609 13.5231C14.1098 13.4996 14.0591 13.4757 14.0086 13.4513Z"
									fill="currentColor"
								/>
							</svg>

							<span className="text-white">
								Learn more about our newest AI Features
							</span>

							<svg
								width="9"
								height="14"
								viewBox="0 0 9 14"
								xmlns="http://www.w3.org/2000/svg"
								className="hidden md:inline text-white">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M5.58586 6.99992L0.292969 12.2928L1.70718 13.707L8.41429 6.99992L1.70718 0.292818L0.292969 1.70703L5.58586 6.99992Z"
									fill="currentColor"
								/>
							</svg>
						</Link>
					</div>

					<div
						className="justify-self-end hover:cursor-pointer text-white hover:text-pictonblue"
						onClick={() => {
							setIsBannerVisible(false)
						}}>
						<svg
							width="12"
							height="12"
							viewBox="0 0 12 12"
							xmlns="http://www.w3.org/2000/svg">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M0.342773 1.75724L1.75699 0.34303L5.99977 4.58574L10.2423 0.34303L11.6565 1.75724L7.41377 5.99974L11.6565 10.2425L10.2423 11.6567L5.99977 7.41374L1.75699 11.6567L0.342773 10.2425L4.58577 5.99974L0.342773 1.75724Z"
								fill="currentColor"
							/>
						</svg>
					</div>
				</div>
			)}
		</>
	)
}

export default TopBanner
